import axios from "axios";

export default {
  getPodium(podiumParams) {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.HAUGAZEL_SERVICE_PUBLIC_PATH}/podium`,
        params: podiumParams
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  },
  getCivilities() {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.HAUGAZEL_SERVICE_PUBLIC_PATH}/civility`,
      })
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/haugazelService.js